import VerifiedIcon from "@mui/icons-material/Verified";

// Small icon-only "Verified" badge, gated on isIdentityVerified — mirrors
// ngwaahia-mobile's components/ui/VerifiedBadge.js. Keep this component
// dumb (no text, no tooltip) so it drops inline next to a name anywhere.
const VerifiedBadge = ({ size = 16, sx }) => (
  <VerifiedIcon
    sx={{ fontSize: size, color: "#046287", flexShrink: 0, ...sx }}
  />
);

export default VerifiedBadge;
